import { createElement } from "react";
import { useQuery } from "hooks/useQuery";
import { getFaqs } from "../service";

export const useFaqs = () => {
  const { isLoading, data } = useQuery({
    queryKey: ["faqs"],
    queryFn: async () => {
      const response = await getFaqs();
      const items = response.map((d) => ({
        title: d.title,
        body: createElement("div", {
          className: "faq-body",
          dangerouslySetInnerHTML: { __html: d.description || "" },
        }),
        section: d.section || "General",
      }));

      const grouped = items.reduce((acc, item) => {
        const existing = acc.find((g) => g.section === item.section);
        if (existing) {
          existing.items.push(item);
        } else {
          acc.push({ section: item.section, items: [item] });
        }
        return acc;
      }, []);

      return { items, grouped };
    },
  });

  return {
    isLoading,
    faqs: data?.items || [],
    groupedFaqs: data?.grouped || [],
  };
};
